/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-useless-concat */
import React, { FC } from 'react';
import { Typography, Table, Tag, Alert, Row, Col, Space } from 'antd';
import type { TableProps } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { useGetApplication } from '~/controllers/wizard';
import theme from '~/constants/theme';
import colors from '~/constants/colors';
import { getStagePayload } from '~/utils/getStagePayload';
import UpdateApplicationButton from './UpdateApplicationButton';
import DeclineReasonsList from './DeclineReasonsList';
import { getErrorMessages } from './utils';

const SoftRejectionWithCardholder: FC = () => {
  const { t } = useTranslation('stageResult');

  const applicationQuery = useGetApplication();
  const softDeclineStagePayload =
    applicationQuery.data?.stage === 'salesforceSoftDecline' ? applicationQuery.data.stagePayload : undefined;
  const businessCommentsCardholder = getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors[0]
    ?.detailedRejectionBusinessCommentsForCardHolder?.length
    ? getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors[0]
        ?.detailedRejectionBusinessCommentsForCardHolder
    : getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors?.map((item) => item?.cardHolderErrorMessage);

  const businessCommentsMerchant = getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors[0]
    ?.detailedRejectionBusinessComments?.length
    ? getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors[0]?.detailedRejectionBusinessComments
    : getStagePayload.salesforceSoftDecline(applicationQuery.data)?.errors?.map((item) => item?.errorMessage);

  type ColumnsType<T extends object> = TableProps<T>['columns'];

  interface DataType {
    key: string;
    name: string;
    age: string;
    address: string;
    tags: string[];
  }

  const columns: ColumnsType<DataType> = [
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'name',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'age',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (tags: string) => (
        <span>
          <Tag color="volcano" key={tags}>
            {tags?.toUpperCase() || ''}
          </Tag>
        </span>
      ),
    },
  ];
  const rejectedCardholderData: any = getStagePayload.salesforceSoftDecline(applicationQuery.data)?.cardholdersRejected;

  return (
    <WizardContent
      content={
        <Container className="SalesforceSoftDecline">
          <Typography.Title style={{ marginBottom: 20 }} className="SalesforceSoftDecline-Title">
            {t('Further Informsssation Required')}
          </Typography.Title>
          <div style={{ height: '20vh', overflowY: 'scroll', marginTop: 0 }} className="SalesforceSoftDecline-Content">
            <div>
              <Typography.Paragraph className="SalesforceSoftDecline-Paragraph">
                <p>
                  {t(
                    'Thank you for your application. We have reviewed the information submitted to us and require some clarifications.',
                  )}
                </p>
                {softDeclineStagePayload?.allowToResubmit ? (
                  <>
                    <p>
                      {t(
                        "We request you to select 'Update Application' below and review the following details which you provided:",
                      )}
                    </p>
                    <p>
                      <>
                        <Typography.Title level={5} className="SalesforceSoftDecline-Title">
                          {t('General Comments')}
                        </Typography.Title>
                        <DeclineReasonsList errors={businessCommentsMerchant} />
                        <Typography.Title level={5} className="SalesforceSoftDecline-Title">
                          {t('Comments for Cardholder(s)')}
                        </Typography.Title>
                        {!!businessCommentsCardholder?.length && (
                          <DeclineReasonsList errors={businessCommentsCardholder} />
                        )}
                      </>
                    </p>
                  </>
                ) : softDeclineStagePayload?.errors.length === undefined ? (
                  <p>{t("We'll call you back soon for further information.")}</p>
                ) : softDeclineStagePayload.errors.length === 1 ? (
                  getErrorMessages(softDeclineStagePayload.errors).map((message) => {
                    return <p key={message.message}>{message}</p>;
                  })
                ) : softDeclineStagePayload.errors.length > 1 ? (
                  <>
                    <DeclineReasonsList errors={businessCommentsMerchant} />
                    <DeclineReasonsList errors={businessCommentsCardholder} />
                  </>
                ) : null}
              </Typography.Paragraph>
            </div>
          </div>

          <div className="SalesforceSoftDecline-ContactUs">
            <BottomLeftActions contactUsUrl={features.contactUsLinkSoftDecline} contactUsTextPosition="left" />
          </div>
          <br />
          <br />
          <Row justify="center">
            <Col span={1}>
              <br />
            </Col>
            <Col span={17}>
              <Typography.Title style={{ marginLeft: -30 }} level={4} className="SalesforceSoftDecline-Title">
                {t("Cardholder's Details")}
              </Typography.Title>
              <Table pagination={{ pageSize: 3 }} columns={columns} dataSource={rejectedCardholderData} />
            </Col>
            <Col span={1}>
              <br />
            </Col>

            <Col style={{ paddingTop: '10%' }} span={4}>
              {softDeclineStagePayload?.allowToResubmit && (
                <div className="SalesforceSoftDecline-UpdateApplicationBtn">
                  <UpdateApplicationButton
                    rejectedCardholderEmails={rejectedCardholderData?.map((item: any) => {
                      return {
                        email: item?.email,
                      };
                    })}
                    title="Update Application & Send Invitation"
                  />
                </div>
              )}
            </Col>
            <Col span={1}>
              <br />
            </Col>
          </Row>
          <div style={{ marginLeft: 40 }}>
            <p>
              <Trans
                t={t}
                i18nKey="Please contact us via our <1>Contact us page</1> if you need any support or have any questions."
              >
                {'Please contact us via our '}
                <a href={features.contactUsLinkSoftDecline} target="__blank">
                  Contact us page
                </a>
                {' if you need any support or have any questions.'}
              </Trans>
            </p>
          </div>
        </Container>
      }
    />
  );
};

const Container = styled.div`
  .SalesforceSoftDecline-Content {
    position: relative;
    width: 80vw;

    .SalesforceSoftDecline-Img {
      //width: 80vw;
      margin-bottom: 32px;
      margin-top: 32px;
      height: 30vh;
    }

    .SalesforceSoftDecline-Paragraph {
      margin-left: 5%;
    }

    .SalesforceSoftDecline-UpdateApplicationBtn {
      margin-top: 80px;
      margin-left: 5%;
      padding-top: 100px;
    }

    @media (max-width: ${theme.breakpoints.md}px) {
      .SalesforceSoftDecline-Title {
        position: static;
        width: 100%;
        border-radius: ${theme.borderRadiusBase}px;
        color: ${colors.primaryTitleColor} !important;
      }
      .SalesforceSoftDecline-Img {
        border-radius: ${theme.borderRadiusBase}px;
      }
      .SalesforceSoftDecline-Paragraph {
        margin-left: 0;
      }
      .SalesforceSoftDecline-UpdateApplicationBtn {
        padding-top: 100px;
      }
    }
  }

  .SalesforceSoftDecline-Content-image {
    position: relative;
    //height: 40vh;
    //background-color: red;
    .SalesforceSoftDecline-Img {
      //width: 85vw;
      margin-bottom: 32px;
      margin-top: 32px;
      height: 30vh;
    }
    .SalesforceSoftDecline-Title {
      position: absolute;
      bottom: 25%;
      left: 5%;
      width: 35%;
      color: ${colors.layoutBodyBackground} !important;
    }
  }
  .SalesforceSoftDecline-ContactUs {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
  .SalesforceSoftDecline-TopLeftActions {
    position: absolute;
    top: 40px;
    right: 40px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    .SalesforceSoftDecline-ContactUs {
      display: none;
    }
  }
`;

export default SoftRejectionWithCardholder;
